import getTranslation from './getTranslation';

/**
 * Remembers which option input has focus inside `root`, so focus can be put back
 * after the markup is swapped (section re-render / async product switch).
 *
 * @param {HTMLElement} root
 * @returns {{ name: string, value: string } | null}
 */
export function captureFocus(root) {
  const el = document.activeElement;
  if (!(el instanceof HTMLInputElement) || !el.name || !root?.contains(el)) {
    return null;
  }
  return { name: el.name, value: el.value };
}

/**
 * Focuses the same option in the new markup, else the closest stand-in:
 * the checked option in that group, then any enabled option in it.
 *
 * @param {HTMLElement} root
 * @param {{ name: string, value: string } | null} snapshot
 */
export function restoreFocus(root, snapshot) {
  if (!snapshot || !root) {
    return;
  }
  const inputs = Array.from(
    root.querySelectorAll(`input[name="${CSS.escape(snapshot.name)}"]`),
  ).filter(input => !input.disabled);
  const target =
    inputs.find(input => input.value === snapshot.value) ||
    inputs.find(input => input.checked) ||
    inputs[0];
  target?.focus();
}

/**
 * Reads the selected options, price and stock out of freshly swapped product
 * markup and drops them into the persistent live region in layout/theme.liquid.
 *
 * @param {HTMLElement} root
 */
export function announceVariant(root) {
  const region = document.querySelector('[data-live-region]');
  if (!region || !root) {
    return;
  }

  const clean = el => el?.textContent.replace(/\s+/g, ' ').trim();
  const options = [
    ...new Set(
      Array.from(
        // Product options plus linked-product radios (length, cup size, gift card type),
        // minus the product-card swatches in the quick view / Make It a Set drawers.
        root.querySelectorAll(
          'input[name^="options"]:checked, input[data-swatch-product-url]:checked:not([name^="product-item-swatches-"])',
        ),
      ).map(input => input.value),
    ),
  ];
  const atc = root.querySelector('[data-add-to-cart]');
  let stock;
  if (atc && !atc.hasAttribute('data-size-select-trigger')) {
    stock = getTranslation(
      atc.type === 'submit' ? 'products.in_stock' : 'products.sold_out',
    );
  }

  region.textContent = [
    ...options,
    clean(root.querySelector('[data-price-wrapper] > span')),
    stock,
    clean(root.querySelector('[data-low-stock]')),
  ]
    .filter(Boolean)
    .join(', ');
}
